import { SAButton, SAColumns, SAPopover, SASelect } from "@saux/design-system-react";
import { useEffect, useState } from "react";
import styled from "styled-components";
import Avatar from "../avatar/Avatar";
import CheckBox from "../checkBox/CheckBox";
import styling from "./DashBoardConverstation.module.css";
import {
  CANCEL,
  COPY,
  CONVERSATION_CONTROL_TABS,
  REMOVE,
  TRANSFER,
  NO_ACTION,
  TRANSFER_ALL,
  COPY_ALL,
  COVER,
  SNACKBAR,
  COVER_ALL,
  REMOVE_ALL,
} from "../../utils/constants";
import DashBoardConversationItem from "../dashBoardConversationItem/DashBoardConversationItem";
import RemoveAdjuster from "../removeAdjuster/RemoveAdjuster";
import AdjusterSearch from "../adjusterSearch/AdjusterSearch";
import { simpleGTMDataLayer } from "../../utils/utilities";
import { useDispatch, useSelector } from "react-redux";
import page_left from "../../icons/Page_Left_Icon.png";
import page_right from "../../icons/Page_Right_Icon.png";
import { formLabelClasses } from "@mui/material";
import snackbarOpen from "../../store/action-creators/snackbarActionCreators";
import Cover from "../Cover/Cover";
import { format } from "date-fns";
import moment from "moment";
import { date } from "faker/locale/zh_TW";
import { database } from "faker/locale/en_AU";

const Rectangle = styled.ul`
  border: 1px solid #e8ebf0;
  width: 100%;
  height: 360px;
  overflow-y: auto;
`;

const Footer = styled.div`
  display: flex;
  margin-top: 20px;
  margin-left: 10px;
  div[data-testid="ColumnWrapper"] {
    width: 100%;
    #action-buttons {
      display: flex;
      button {
        margin-left: 10px;
      }
      #remove:enabled {
        color: red;
        border: 1px solid red;
      }
    }
  }
`;

const SAGrids = styled(SAColumns)`
  margin-top: 40px;
`;

const Popover = styled(SAPopover)`
 ul li.active a {
    color: #979797
  }
`;


const PageHeader = styled.div`
  margin-bottom: 30px;
  .left {
    margin-left: 20px;
  }
  .right {
    margin-top: 10px;
  }
  .page-button {
    text-align: center;
    width: 65%; 
  }
  .page-button.enable {
    cursor: pointer;
    border-radius: 50%;
    &:hover {
      background-color: #eeedee;
    }
  }
`;

export default function DashBoardConversations(props: any) {
  const [isSelectedAll, setSelectedAll] = useState(false);
  const [featureValv, setFeatureValv] = useState(COVER);
  const [selectedButton, setSelectedButton] = useState(NO_ACTION);
  const [selectedConversations, setSelectedConversations] = useState<any>({});
  const [convCount, setConvCount] = useState<string>('');
  const [viewFlag,setViewFlag] =useState(false);
  const [selectedConversationsCount, setSelectedConversationsCount] = useState(
    0
  );
  const [referenceElement, setReferenceElement] = useState<Element | null>(
    null
  );
  const user = useSelector((state: any) => state.user);
  const [conversations, setConversation] = useState(props.conversations);
  const dispatch = useDispatch();


  const nextAction = () => {
    let action;
    if (convCount) {
      action = `${featureValv} ${convCount}`;
    }
    else {
      action = featureValv
    }
    if (selectedConversationsCount || convCount) {
      handleButton(action);
    }
    else {
      dispatch(
        snackbarOpen({
          open: true,
          message: "Please select the conversation",
          type: SNACKBAR.ERROR,
        })
      );

    }
  }

  const filterChange = (e: any) => {
    setSelectedAll(false);
    setSelectedConversations({});
    props?.setFilterDD('Display Range');
   // props.setConversationsEmpty();
    props?.setFilter(e.target.checked);
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Filter-Toggle-Click`,
      event_action: 'Toggle Click',
      event_category: window.location.pathname,
      event_label: `Filter toggle turn on/off`,
      event_value: `${user.fullName} turned ${e.target.checked ? "on" : "off"} filter toggle.`
    });
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Filter-Toggle-Click-Snowplow`,
      event_action: 'Toggle Click',
      event_category: window.location.pathname + "/Snowplow",
      event_label: `Filter toggle turn on/off`,
      event_value: `${user.fullName} turned ${e.target.checked ? "on" : "off"} filter toggle.`
    });
  };

  const handleChangeFilter = (value: any) => {
    //  if (value !== 'Display Range') {
    props.setConversationsEmpty();
    setSelectedAll(false);
    setSelectedConversations({});
    props?.setFilterDD(value);
    if(value!=="Display Range"){
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Display-Range-Dropdown-Click`,
      event_action: 'Button Click',
      event_category: window.location.pathname,
      event_label: `Select Display Range`,
      event_value: `${user.fullName} selected last ${value} days conversations.`
    });
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Display-Range-Dropdown-Click-Snowplow`,
      event_action: 'Button Click',
      event_category: window.location.pathname + "/Snowplow",
      event_label: `Select Display Range`,
      event_value: `${user.fullName} selected last ${value} days conversations.`
    });
  }
    getDate(value); 
  };

  const getDate=(value:any)=>{
    let data: any = "";
    if (!isNaN(value)) {
      let tempDate = new Date();
      let newDate = new Date(
        Date.UTC(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate() - +value)
      );
      data = getFormattedDate(newDate);
      props?.getFilterInput(data);
    }
    else {
      data = "01/01/2000";
      props?.getFilterInput(data);
      // props?.setFilter(false);
    }
  }

  const getFormattedDate = (date: Date) => {
    var year = date.getFullYear();

    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    var day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    return month + '/' + day + '/' + year;
  }

  useEffect(() => {
    let count = Object.keys(selectedConversations).length;
    setSelectedConversationsCount(count);
  }, [selectedConversations]);

  const getMyConversationsLabel = (value: string) => {
    switch (value) {
      case NO_ACTION:
        return CANCEL;
      case REMOVE:
        return REMOVE;
      case TRANSFER:
        return TRANSFER;
      case COPY:
        return COPY;
      case TRANSFER_ALL:
        return TRANSFER + " " + props.totalCount;
      case REMOVE_ALL:
        return TRANSFER + " " + props.totalCount;
      case COPY_ALL:
        return COPY + " " + props.totalCount;
      case COVER_ALL:
        return COVER + " " + props.totalCount;
      case COVER:
        return COVER;
      default:
        return "";
    }
  };

  const getEventActionType = () => {
    if (props.selectedType === CONVERSATION_CONTROL_TABS.MYCONVERSATIONS) {
      return "My-Conversations";
    }
    return "All-Conversations";
  };

  const isToday = (someDate: Date) => {
    const today = new Date();
    return (
      someDate.getDate() == today.getDate() &&
      someDate.getMonth() == today.getMonth() &&
      someDate.getFullYear() == today.getFullYear()
    );
  };


  const handleButton = (value: string, isGTMEventTriggerNeeded = true) => {
    if (isGTMEventTriggerNeeded) {
      let label = getMyConversationsLabel(value);
      simpleGTMDataLayer({
        csrId: user.userName,
        event: `${getEventActionType()}-${label}-Click`,
        event_action: "Button Click",
        event_category: window.location.pathname,
        event_label: `${label} Actions for Conversations`,
        event_value: `${label} action triggered by ${user.fullName} in ${props.selectedType}`,
      });
      simpleGTMDataLayer({
        csrId: user.userName,
        event: `${getEventActionType()}-${label}-Click-Snowplow`,
        event_action: "Button Click",
        event_category: window.location.pathname + "/Snowplow",
        event_label: `${label} Actions for Conversations`,
        event_value: `${label} action triggered by ${user.fullName} in ${props.selectedType}`,
      });
    }
    setSelectedButton(value);
  };


  const handleViewConversations = () => {
     props?.setConversations([]);
     props?.updatePage(0);
     props?.setCount(0);
     props?.getFilterInput(undefined);
     props?.setFilter(false);
     setSelectedConversations({});
     props?.setConversationsEmpty();

    handleButton(NO_ACTION, false);
  
    //props?.fetchConversations();
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `View-Conversations-Click`,
      event_action: "Button Click",
      event_category: window.location.pathname,
      event_label: `It's for getting back to conversations page.`,
      event_value: `View conversations action triggered by ${user.fullName}`,
    });

    simpleGTMDataLayer({
      csrId: user.userName,
      event: `View-Conversations-Click-Snowplow`,
      event_action: "Button Click",
      event_category: window.location.pathname + "/Snowplow",
      event_label: `It's for getting back to conversations page.`,
      event_value: `View conversations action triggered by ${user.fullName}`,
    });
    setViewFlag(true);
  };

  useEffect(()=>{
    if(viewFlag===true){
      props?.fetchConversations();
      setViewFlag(false);
    }
  },[viewFlag])

  const handleSelectedConversations = (id: any, selected: boolean) => {
    if (selected) {
      setSelectedConversations((selectedConversations: any) => {
        return { ...selectedConversations, [id]: conversations[id] };
      });
    } else {
      let updatedConversations = { ...selectedConversations };
      delete updatedConversations[id];
      setSelectedConversations({ ...updatedConversations });
      setSelectedAll(false);
    }
  };

  const getSelectedComponent = () => {
    switch (selectedButton) {
      case REMOVE:
      case REMOVE_ALL:
        return (
          <RemoveAdjuster
            count={
              selectedButton === REMOVE_ALL
                ? props.totalCount
                : selectedConversationsCount
            }
            selectedConversations={selectedConversations}
            handleCancel={() => handleButton(NO_ACTION)}
            selectedAdjuster={props.selectedAdjuster}
            selectedType={props.selectedType}
            setConversationsEmpty={props.setConversationsEmpty}
            handleViewConversations={handleViewConversations}
          />
        );
      case TRANSFER:
      case COPY:
      case TRANSFER_ALL:
      case COPY_ALL:
        return (
          <AdjusterSearch
            selectedConversations={selectedConversations}
            count={
              selectedButton === TRANSFER_ALL || selectedButton === COPY_ALL
                ? props.totalCount
                : selectedConversationsCount
            }
            fromAdjuster={props.selectedAdjuster}
            selectedType={props.selectedType}
            //setFilter={props.setFilter}
            //getFilterData = {props.getFilterInput}
            selectedButton={selectedButton}
            handleNewSearch={props.handleCancel}
            setConversationsEmpty={props.setConversationsEmpty}
            handleViewConversations={handleViewConversations}
            handleCancel={() => handleButton(NO_ACTION)}
          />
        );
      case COVER:
      case COVER_ALL:
        return (
          <Cover
            selectedConversations={selectedConversations}
            count={
              selectedButton === COVER_ALL
                ? props.totalCount
                : selectedConversationsCount
            }
            fromAdjuster={props.selectedAdjuster}
            selectedType={props.selectedType}
            selectedButton={selectedButton}
           // setFilter={props.setFilter}
           // getFilterData = {props.getFilterInput}
            handleNewSearch={props.handleCancel}
            setConversationsEmpty={props.setConversationsEmpty}
            handleViewConversations={handleViewConversations}
            handleCancel={() => handleButton(NO_ACTION)}

          />
        );

      default:
        break;
    }
  };

  const handleSelectAll = (value: boolean) => {
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `SelectAll-Checkbox-Click`,
      event_action: "Checkbox Click",
      event_category: window.location.pathname,
      event_label: `User can select "Select All" checkbox if they want to select all the conversations.`,
      event_value: `${user.fullName} has ${value ? "checked" : "unchecked"
        } the 'Select All' checkbox.`,
    });
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `SelectAll-Checkbox-Click-Snowplow`,
      event_action: "Checkbox Click",
      event_category: window.location.pathname + "/Snowplow",
      event_label: `User can select "Select All" checkbox if they want to select all the conversations.`,
      event_value: `${user.fullName} has ${value ? "checked" : "unchecked"
        } the 'Select All' checkbox.`,
    });
    const getConversations = () => {
      let updatedSelectedConversations: any = {};
      conversations.forEach((con: any, index: any) => {
        updatedSelectedConversations[index] = con;
      });
      return updatedSelectedConversations;
    };
    if (value) {
      let updatedSelectedConversations = getConversations();
      setSelectedConversations({ ...updatedSelectedConversations });
    } else {
      setSelectedConversations({});
    }
    setSelectedAll(value);
  };

  const previousPage = () => {
    if (props.page !== 0) {
      props.updatePage(props.page - 1);
      setSelectedConversations({});
      setSelectedAll(false);
      if(props?.isfilter){
        getDate(props?.filterDD);
      }
    }
  };

  const nextPage = () => {
    if (props.page * 100 + conversations.length < props.totalCount) {
      props.updatePage(props.page + 1);
      setSelectedConversations({});
      setSelectedAll(false);
      if(props?.isfilter){
        getDate(props?.filterDD);
      }
    }
  };

  const handleMenuOptions = (event: React.MouseEvent<HTMLElement>) => {
    setReferenceElement(event.currentTarget);
  }

  const handleClose=(event: React.MouseEvent<HTMLElement> | MouseEvent,index: number | null) =>{
    setReferenceElement(null);
    if (index === 0) {
      props?.setSortFlag(true);
    }
    else{
      props?.setSortFlag(false);
    }
  }


  return (
    <div data-testid="dashboard-conversations">
      {selectedButton === NO_ACTION &&
        props.selectedType === CONVERSATION_CONTROL_TABS.ALLCONVERSATIONS && (
          <div style={{ display: "flex", marginBottom: 10 }}>
            <Avatar
              name={props.selectedAdjuster.adjusterName}
              style={{ marginLeft: 0 }}
            />
            <div
              style={{ fontWeight: "bold", marginTop: 7 }}
            >{`${props.selectedAdjuster.adjusterName} Conversations`}</div>
          </div>
        )}
      {conversations.length > 0 && selectedButton === NO_ACTION ? (
        <PageHeader>
          <SAGrids columns={[10, 2]}>
            <div className="left">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "320px",
                }}
              >
                <CheckBox
                  id="selectAll"
                  name="selectAll"
                  data-testid="test-selectAll"
                  isChecked={isSelectedAll}
                  label={""}
                  handleChange={(value) => handleSelectAll(value)}
                />
                <div style={{ marginTop: "5px", marginLeft: "10px" }} data-testid="filter-label">
                  FILTER
                </div>
                <label className={styling.filter}>
                  <input
                    type="checkbox"
                    data-testid="filter-toggle"
                    style={{ marginLeft: "10px" }}
                    onChange={filterChange}
                    checked={props.isfilter}
                  />
                  <span
                    className={`${styling.toggle} ${styling.round}`}
                  ></span>
                </label>
                <div
                  data-testid="range-select"
                  style={
                    props.isfilter
                      ? {
                        visibility: "visible",
                        marginTop: "-15px",
                        marginLeft: "20px",
                      }
                      : {
                        visibility: "hidden",
                        marginTop: "-15px",
                        marginLeft: "20px",
                      }
                  }
                >
                  <SASelect
                    fullWidth
                    data-testid="dynamic-select"
                    onChange={(e: any) => handleChangeFilter(e.target.value)}
                    style={{ backgroundColor: "white" }}
                    label={props.isfilter ? "Display Range" : ""}
                    id="DynamicSelect"
                    value={props.filterDD}
                    options={[
                      { label: "Display Range", value: "Display Range" },
                      { label: "Last 30 days", value: "30" },
                      { label: "Last 60 days", value: "60" },
                      { label: "Last 90 days", value: "90" },
                      { label: "Last 120 days", value: "120" },
                    ]}
                    className="select_SA"
                  />
                </div>
              </div>

            </div>
            <div className="right">
              <SAColumns columns={[8, 2, 2]}>   
                <span style={{textAlign:"center",borderRadius:"5px",backgroundColor:"#E3E9F1",padding:"5px 15px"}} onClick={handleMenuOptions}> 
                  {props.page * 100 + 1}-
                  {props.page * 100 + conversations.length} of{" "}
                  {props.totalCount}
                </span>      
                <div
                  className={
                    "page-button" + (props.page !== 0 ? " enable" : "")
                  }
                  onClick={previousPage}
                >
                  <img src={page_left} alt="#" />
                </div>
                <div
                  className={
                    "page-button" +
                    (conversations.length === 100 ? " enable" : "")
                  }
                  onClick={nextPage}
                >
                  <img src={page_right} alt="#" />
                </div>
              </SAColumns>
            </div>
          </SAGrids>
        </PageHeader>
      ) : (
        <></>
      )}
      {selectedButton === NO_ACTION ? (
        <div>
          <Rectangle
            style={{
              height:
                props.selectedType ===
                  CONVERSATION_CONTROL_TABS.ALLCONVERSATIONS
                  ? "43vh"
                  : "50vh",
            }}
          >
            {(conversations || [])
              .map((con: any, index: any) => {
                return (
                  <DashBoardConversationItem
                    key={con.conversationId}
                    index={index}
                    conversation={con}
                    selectedConversations={selectedConversations}
                    isSelectedAll={isSelectedAll}
                    handleSelectedConversations={handleSelectedConversations}
                  />
                );
              })}
          </Rectangle>
          <Footer>
            <SAColumns>

              <div id="action-buttons" style={{ justifyContent: "flex-end", position: "absolute", right: "0px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ display: "flex" }}>
                    <div style={{ marginRight: 30 }}>
                      <SASelect
                        fullWidth
                        data-testid="action-select"
                        style={{ backgroundColor: "white", width: "225px" }}
                        label={"Function"}
                        onChange={(e: any) => { setFeatureValv(e.target.value) }}
                        value={featureValv}
                        id="select01"
                        options={props.selectedType ===
                          CONVERSATION_CONTROL_TABS.MYCONVERSATIONS ? [
                          { label: "COVER", value: COVER },
                          { label: "COPY", value: COPY },
                          { label: "TRANSFER", value: TRANSFER },
                          { label: "REMOVE", value: REMOVE },
                        ] : [
                          { label: "COVER", value: COVER },
                          { label: "COPY", value: COPY }
                        ]}
                        className="select_SA"
                      />
                    </div>
                    <div style={{ marginRight: 20 }}>
                      <SASelect
                        fullWidth
                        data-testid="convcount-select"
                        style={{ backgroundColor: "white", width: "198px" }}
                        label={"Conversation Count"}
                        value={convCount}
                        onChange={(e: any) => { setConvCount(e.target.value) }}
                        id="functionSelect"
                        options={[
                          { label: `Selected ${selectedConversationsCount}`, value: "" },
                          { label: `All - ${props.totalCount}`, value: "All" }
                        ]}
                        className="select_SA"
                      />
                    </div>
                  </div>

                  <SAButton
                    style={{ marginRight: "80px" }}
                    id="next"
                    label={"NEXT"}
                    onClick={nextAction}
                    variant="medium"
                    color="secondary"
                  />
                </div>

              </div>
            </SAColumns>
          </Footer>
        </div>
      ) : (
        getSelectedComponent()
      )}
      <SAPopover
          data={[
            "Newest",
            "Oldest"
          ]}
          onClose={(e: MouseEvent, index: number | null) =>
            handleClose(e, index)
          }
          placement="bottom-start"
          referenceElement={referenceElement}
          variant="popover-menu"
        />
    </div>
  );
}

